<template>
  <div class="choose">
    <el-row style="height: 350px;line-height:350px;width: 100%">
      <el-col :push="1" :span="4" style="margin-top: 60px">
        <el-card :body-style="{ padding: '0px' }" shadow="hover" style="width:100%;height: 200px;background-color: white;cursor: pointer">
          <img style="position: absolute;top: 25px;left: 80px" src="../assets/1.svg" width="100" height="100" alt="">
          <span>新建会议</span>
        </el-card>
      </el-col>
      <el-col :push="3" :span="4" style="margin-top: 60px">
        <el-card :body-style="{ padding: '0px' }" shadow="hover" style="width:100%;height: 200px;background-color: white;cursor: pointer">
          <img style="position: absolute;top: 25px;left: 80px" src="../assets/2.svg" width="100" height="100" alt="">
          <span>会议管理</span>
        </el-card>
      </el-col>
      <el-col :push="5" :span="4" style="margin-top: 60px">
        <el-card :body-style="{ padding: '0px' }" shadow="hover" style="width:100%;height: 200px;background-color: white;cursor: pointer">
          <img style="position: absolute;top: 25px;left: 80px" src="../assets/4.svg" width="100" height="100" alt="">
          <span>搜索会议</span>
        </el-card>
      </el-col>
      <el-col :push="7" :span="4" style="margin-top: 60px">
        <el-card :body-style="{ padding: '0px' }" shadow="hover" style="width:100%;height: 200px;background-color: white;cursor: pointer">
          <img style="position: absolute;top: 25px;left: 80px" src="../assets/3.svg" width="100" height="100" alt="">
          <span>会议数据</span>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
name: "choose"
}
</script>

<style scoped lang="less">
.choose{
  background-color: #f2f2f2;
  color: #333;
  text-align: center;
  line-height: 350px;
  height: 350px;
}
</style>
